import { useNavigate } from "react-router-dom";
import FooterPrestataire from "../../components/FooterPrestataire";
import MultiStep from "../../components/multiStep";
import { useEffect } from "react";
import TopHeader from "../../components/TopHeader";

const LayoutPro=(props)=>{
  // console.log({props})
    const navigate=useNavigate()
    const initializeSteps = () => {
      // console.log("Running initializeSteps");
      const existingSteps = localStorage.getItem("stepsStatus");
      // console.log("Existing stepsStatus:", existingSteps);
    
      if (!existingSteps) {
        // console.log("Initializing stepsStatus in localStorage");
        const initialSteps = {
          1: "notStarted",
          2: "notStarted",
          3: "notStarted",
          4: "notStarted",

        };
        localStorage.setItem("stepsStatus", JSON.stringify(initialSteps));
      } else {
        // console.log("stepsStatus already exists in localStorage");
      }
    };
    const steps=[
      {
        path: "/personalInformations",
        label: "Informations personnelles",
        step: 1,
        
      },
      { path: "/choiceFormula", 
        label: "Choix de la formule", 
        step: 2 },
      {
        path: "/billingaddress",
        label: "Adresse de facturation",
        step: 3,
      },
      { path: "/paiement", label: "Paiement", step: 4 },

    ]
    useEffect(() => {
      // console.log("Component mounted");
      initializeSteps();
    }, []);

    return (
        <>
           <TopHeader btn={props?.btn} />
          <MultiStep
            steps={steps}
            currentStep={props?.currentStep}
          />
          <div className="col-lg-12 mx-auto bg-auth">{props?.children}</div>
      
          <FooterPrestataire
            handleSubmit={props.handleSubmit}
            nameButton={props.nameBtnSubmit}
            plan={props?.plan}
             // Conditionally show 'linkRoute' and 'linkName' only if currentStep > 1
            linkRoute={props.currentStep > 1 ? steps[props.currentStep - 2].path : null}
            linkName={props.currentStep > 1 ? "Étape précédente" : null}
            isSubmitting={props?.disabled}
        />
        </>
      );
}
export default LayoutPro